import _ from 'lodash'
import axios from 'axios'

export const _Rayons = {
  namespaced: true,
  state: {
    /**
     * Liste des rayons
     * @type {Array}
     */
    rayons: [],
    allrayons: [],
    allproducts: []
  },
  getters: {
    /**
     * @return {Array} liste des titre des rayons
     */
    GET_ALL_RAYON_TITLE (state) {
      let list = []
      _.forEach(state.allrayons, rayon => {
        list.push({ text: rayon.title, value: rayon.id, subs: rayon.subs })
      })
      return list
    },
    /**
     * @return {Array} liste des titre des rayons
     */
    GET_RAYON_TITLE (state) {
      let list = []
      _.forEach(state.rayons, rayon => {
        list.push({ text: rayon.title, value: rayon.id, subs: rayon.subs })
      })
      return list
    },
    /**
     * indique si le nom du rayon est déjà présent dans la liste
     * @param {Object} rayon à vérifier
     * @return {Rayon} retourne le rayon recherché
     */
    GET_RAYON_BY_ID: state => id => {
      return _.cloneDeep(state.rayons.find(rayon => rayon.id === id))
    },
    GET_RAYON_BY_TITLE: state => title => {
      return _.cloneDeep(state.rayons.find(rayon => rayon.title === title))
    },
    /**
     * Indique si la rayon est une sous rayon
     * @return {Integer}       ID de la rayon parente sinon null
     */
    IS_SUB_RAYON: state => rayon => {
      // n'est pas une sous rayon
      if (rayon.sub === '0' || rayon.sub === rayon.id) {
        return null
      }
      return rayon.sub
    },
    /**
     * Retourne toutes les products qui matchent avec la recherche
     * @return {Array} de toutes les products
     */
    GET_PRODUCTS: (state, getters) => search => {
      // si la recherche fait moins de 3 caractères
      // pas de recherche
      if (!search || search.length < 3) {
        return []
      }
      // recherche de toutes les products
      let products = []
      _.each(state.rayons, rayon => {
        products.push(rayon.products)
        if (rayon.subs) {
          _.each(rayon.subs, sub => {
            products.push(sub.products)
          })
        }
      })
      products = _.flattenDeep(products)
      // recherche parmis toutes les products
      search = search.toString().toLowerCase()
      return _.filter(products, s => {
        return _.includes(s.title.toLowerCase(), search)
      })
    },
    /**
     * Retourne toutes les products
     * @return {Array} de toutes les products
     */
    GET_ALL_RAYONS (state) {
      return _.cloneDeep(state.rayons)
    }
  },
  mutations: {
    INIT (state) {
      state.rayons = []
    },
    /**
     * Défini la liste de rayon gérée par le store
     * @param {Object} rayons nouvelle rayon gérée
     */
    SET_RAYONS (state, rayons) {
      state.rayons = rayons
    },
    /**
     * Ajoute une rayon dans la liste
     * @param {Object} rayon nouvelle rayon ajoutée
     */
    ADD_RAYON (state, rayon) {
      // check s'il s'agit d'une sous-rayon
      let isSub = _.isNil(rayon.subs)
      // s'il s'agit d'une rayon et non d'une sous-rayon
      if (!isSub) {
        state.rayons.push(rayon)
      } else {
        // recherche de l'indice de la rayon parente dans la liste des rayons
        let idxParent = _.findIndex(state.rayons, {'id': rayon.sub})
        // mise à jour de le rayon
        state.rayons[idxParent].subs.push(rayon)
      }
    },
    /**
     * Ajoute tous les produits apres retour requette en base
     */
    ADD_ALLPRODUCTS (state, products) {
      state.allproducts = products
    },
    /**
     * Ajoute tous les rayons apres retour requette en base
     */
    ADD_ALLRAYONS (state, rayons) {
      state.allrayons = rayons
    },
    /**
     * Met à jour un rayon de la liste
     * @param  {Object} rayon nouvelle valeur de la rayon à mettre à jour
     */
    UPDATE_RAYON (state, rayon) {
      // check s'il s'agit d'une sous-rayon
      let isSub = _.isNil(rayon.subs)
      // s'il s'agit d'une rayon et non d'une sous-rayon
      if (!isSub) {
        let idx = _.findIndex(state.rayons, {'id': rayon.id})
        state.rayons.splice(idx, 1, rayon)
      } else {
        // recherche de l'indice de la rayon parente dans la liste des rayons
        let idxParent = _.findIndex(state.rayons, {'id': rayon.sub})
        // recherche de l'indice de la sous-rayon que l'on veut mettre à jour
        let idxSub = _.findIndex(state.rayons[idxParent].subs, {'id': rayon.id})
        // mise à jour de la sous-rayon
        state.rayons[idxParent].subs.splice(idxSub, 1, rayon)
      }
    },
    /**
     * Supprime une rayon de la liste
     * @param  {Object} rayon à supprimer
     */
    REMOVE_RAYON (state, rayon) {
      // check s'il s'agit d'une sous-rayon
      let isSub = _.isNil(rayon.subs)
      // s'il s'agit d'une rayon et non d'une sous-rayon
      if (!isSub) {
        let idx = _.findIndex(state.rayons, {'id': rayon.id})
        state.rayons.splice(idx, 1)
      } else {
        // recherche de l'indice de la rayon parente dans la liste des rayons
        let idxParent = _.findIndex(state.rayons, {'id': rayon.sub})
        // recherche de l'indice de la sous-rayon que l'on veut mettre à jour
        let idxSub = _.findIndex(state.rayons[idxParent].subs, {'id': rayon.id})
        // mise à jour de la sous-rayon
        state.rayons[idxParent].subs.splice(idxSub, 1)
      }
    }
  },

  actions: {
    /**
     * Récupère les rayons en BDD
     * formate le résultat et le stock dans le store
     */
    GET ({ commit, state, getters }, agentId) {
      return new Promise((resolve, reject) => {
        // Reset des rayons
        commit('INIT')

        // requête
        axios.get('get/products.php?agentId=' + agentId)
        .then(response => {
          let list = response.data
          // state.allproducts = list['products']
          commit('ADD_ALLPRODUCTS', list['products'])
          // state.allrayons = list['rayons']
          commit('ADD_ALLRAYONS', list['rayons'])
          // Création de la rayon par défaut si aucune rayon
          let rayonDefault = false
          if (Array.isArray(list['products'])) {
            for (var i = 0; i < list['products'].length; i++) {
              if (list['products'][i].ray_id === '0') {
                rayonDefault = true
              }
            }
          } else {
            console.warn('list["products"] n\'est pas un tableau:', list['products'])
          }
          if (rayonDefault) {
            commit('ADD_RAYON', {
              id: '0',
              title: 'Produits non classés',
              products: [],
              subs: []
            })
          }
          // parcours de la liste de rayons
          // afin de créer les rayons persos
          // ainsi que les sous-rayons
          _.each(list['rayons'], rayon => {
            // initialisation de la liste de products de la rayon
            rayon.products = []
            let rayonExists = getters.GET_RAYON_BY_ID(rayon.id)
            let isSub = getters.IS_SUB_RAYON(rayon)
            // si pas trouvé et pas une sous-rayon
            // alors on l'ajoute dans la liste des rayons du store
            if (!rayonExists && !isSub) {
              rayon.subs = []
              commit('ADD_RAYON', rayon)
            } else if (isSub) {
              // ajouter la sous-rayon dans la rayon parent
              let parent = getters.GET_RAYON_BY_ID(isSub)
              parent.subs.push(rayon)
              commit('UPDATE_RAYON', parent)
            }
          })

          // parcours de la liste de products
          _.each(list['products'], product => {
            // recherche de la rayon avec son id
            let rayonFound = _.cloneDeep(_.find(state.rayons, { 'id': product.ray_id }))
            // si trouvé alors on ajoute la product dans la rayon trouvée
            if (rayonFound) {
              // création du tableau de products si n'existe pas
              if (!rayonFound.products) { rayonFound.products = [] }
              // ajout de la product parcouru dans la rayon
              rayonFound.products.push({
                id: product.id,
                ref: product.ref,
                title: product.title,
                img: product.img,
                link: product.link,
                price: product.price,
                keywords: product.keywords,
                shortdesc: product.shortdesc,
                addtocart: product.addtocart === '1'
              })
              commit('UPDATE_RAYON', rayonFound)
            } else {
              // savoir si la product est dans une sous-rayon
              // alors on l'ajoute dedans
              _.each(state.rayons, rayon => {
                let rayonCloned = _.cloneDeep(rayon)
                _.each(rayonCloned.subs, sub => {
                  if (product.ray_id === sub.id) {
                    sub.products.push({
                      id: product.id,
                      ref: product.ref,
                      title: product.title,
                      img: product.img,
                      link: product.link,
                      price: product.price,
                      keywords: product.keywords,
                      shortdesc: product.shortdesc,
                      addtocart: product.addtocart === '1'
                    })
                  }
                })
                commit('UPDATE_RAYON', rayonCloned)
              })
            }
          })
          resolve(state)
        })
        .catch(e => {
          reject(e)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/rayons.js